<template>
  <div class="d-flex">
    <!-- ROOM TYPE -->
    <div style="width: 320px;" class="flex-0 mr-3">
      <div class="sticky mb-1"
        :class="{
          'top-5':(!header_scroll || show_rate || show_rate_breakdown) && getMerchant().booking_engine_header_type == 'BANNER',
          'top-90':(!header_scroll || show_rate || show_rate_breakdown) && getMerchant().booking_engine_header_type == 'NAVBAR'}"
        style="top: 185px;">
        <div class="bg-white rounded-4 my-2 light-card-shadow">
          <div class="row slim-grid-row">
            <div class="col-12 mb-1">
              <div class="position-relative">
                <template v-if="type.image == 0">
                  <div class="carousel-cell w-100">
                    <div class="h-img-nearby">
                      <img src="https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png"
                        class="object-fit rounded-4 w-100 h-img-nearby">
                    </div>
                  </div>
                </template>
                <template v-else>
                  <flickity ref="flickity" class="room-detail h-img-nearby text-center"
                    :options="flickityOptionsRoom">
                    <div class="carousel-cell w-100" 
                      :id="slider_room_type.id"
                      @mouseover="sliderPreviousNext(true)"
                      @mouseleave="sliderPreviousNext(false)"
                      v-for="slider_room_type in type.image">
                      <div class="h-img-nearby">
                        <img :src="slider_room_type.image_url"
                          class="object-fit rounded-4 w-100 h-img-nearby">
                      </div>
                    </div>
                  </flickity>
                  <div class="slider-action-btn prev" @click="slideTheSlider('prev')">
                    <svg class="transform-180" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
                      <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
                    </svg>
                  </div>
                  <div class="slider-action-btn next" @click="slideTheSlider('next')">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
                      <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
                    </svg>
                  </div>
                </template>
                <div :id="type.id" class="position-absolute cursor-pointer" style="right: 10px;bottom: 10px;" @click="$copyText(room_type_url,`${$t('hotel.unit-type.'+type.type+'.unit')} URL copied!`)">
                  <img src="../../../../assets/img/icon/share-outline-white.svg" width="30">
                </div>
                <b-tooltip :target="type.id" placement="right" :title="`Share ${$t('hotel.unit-type.'+type.type+'.unit')} via url`">
                </b-tooltip>
              </div>
            </div>
          </div>
          <div class="pt-2 pb-3 px-3 position-relative">
            <!-- ROOM TYPE NAME -->
            <div class="mb-3">
              <p class="mb-0 body-2-2 font-bold text-18 d-block cursor-pointer" @click="onBack('room_type_detail', type);onBack('handlePopupFilter', 'detail-room')">{{type.name}}</p>
            </div>

            <!-- SPECIFICATION -->
            <div class="w-100 mb-4">
              <!-- Room Size -->
              <div v-if="$isNotEmptyV3(type.room_size)" class="w-100 mb-2-5 d-flex">
                <svg class="mr-2 flex-0" height="18" width="18" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.72896 16.9297H13.271C15.0962 16.9297 16 16.0258 16 14.2355V3.62388C16 1.83355 15.0962 0.929688 13.271 0.929688H2.72896C0.912549 0.929688 0 1.82486 0 3.62388V14.2355C0 16.0345 0.912549 16.9297 2.72896 16.9297Z" fill="#777"/>
                  <path d="M2.84192 9.68133L2.87669 6.54392C2.87669 6.38748 2.94621 6.21366 3.0505 6.10937C3.28516 5.86603 3.6241 5.86603 3.86745 6.10937C3.98043 6.22235 4.04996 6.3701 4.04127 6.52653L4.02389 7.85625L3.99781 8.33424L4.27592 8.03007L8.37806 3.92795C8.62139 3.69329 8.97774 3.69329 9.20372 3.92795C9.44705 4.17129 9.43837 4.51893 9.20372 4.75358L5.11025 8.85568L4.78869 9.14254L5.29276 9.12511L6.61379 9.10776C6.77023 9.10776 6.90928 9.15989 7.03095 9.28159C7.26561 9.51625 7.26561 9.84649 7.02226 10.0811C6.92666 10.1854 6.77023 10.255 6.6051 10.2637L3.45028 10.2984C3.12872 10.3071 2.84192 10.0203 2.84192 9.68133ZM13.1754 8.16043L13.1407 11.3152C13.132 11.4804 13.0798 11.6455 12.9756 11.7411C12.7409 11.9758 12.3932 11.9758 12.1586 11.7411C12.0456 11.6194 11.9935 11.4804 11.9935 11.324L12.0108 9.99422L12.0456 9.49882L11.7502 9.82039L7.63933 13.9138C7.40466 14.1572 7.05702 14.1485 6.82237 13.9138C6.57902 13.6705 6.57902 13.3315 6.82237 13.0969L10.9245 8.98606L11.2461 8.70795L10.742 8.72537L9.40359 8.75141C9.25585 8.75141 9.1168 8.69059 8.9951 8.57757C8.76045 8.34292 8.76045 8.01269 9.00378 7.76065C9.10805 7.66505 9.28189 7.58683 9.42094 7.58683L12.5757 7.56075C12.906 7.56075 13.1754 7.8128 13.1754 8.16043Z" fill="white"/>
                </svg>
                <p class="mb-0 body-2-1">{{ `${$capitalize(type.type)} size :` }} {{type.room_size}}m²</p>
              </div>

              <!-- Max Guest -->
              <div v-if="$isNotEmptyV3(type.max_guests)" class="w-100 mb-2-5 d-flex">
                <svg class="mr-2 flex-0" width="18" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.67617 7.96519C7.11451 7.96519 8.36733 6.66604 8.36733 4.98791C8.36733 3.31754 7.10679 2.0957 5.67617 2.0957C4.2378 2.0957 2.97728 3.34848 2.97728 5.00338C2.97728 6.66604 4.23006 7.96519 5.67617 7.96519ZM1.36104 14.9483H9.97584C10.958 14.9483 11.3369 14.5616 11.3369 13.8579C11.3369 11.7235 9.15611 9.14839 5.66844 9.14839C2.18076 9.14839 0 11.7235 0 13.8579C0 14.5616 0.38666 14.9483 1.36104 14.9483Z" fill="#777"/>
                  <path d="M9.71293 16H19.4335C21.4673 16 22.1324 15.0179 22.1324 13.9198C22.1324 11.3214 19.1551 8.11987 14.5693 8.11987C9.99128 8.11987 7.01401 11.3214 7.01401 13.9198C7.01401 15.0179 7.67905 16 9.71293 16Z" fill="white"/>
                  <path d="M14.5771 7.78735C16.2397 7.78735 17.6703 6.30256 17.6703 4.36926C17.6703 2.45916 16.232 1.04398 14.5771 1.04398C12.9222 1.04398 11.4838 2.49009 11.4838 4.38473C11.4838 6.30256 12.9144 7.78735 14.5771 7.78735ZM9.71294 14.9483H19.4335C20.6477 14.9483 21.0807 14.6003 21.0807 13.9198C21.0807 11.9246 18.5829 9.17156 14.5693 9.17156C10.5636 9.17156 8.06577 11.9246 8.06577 13.9198C8.06577 14.6003 8.49879 14.9483 9.71294 14.9483Z" fill="#777"/>
                </svg>
                <p class="mb-0 body-2-1 d-inline-block align-middle">Max {{type.max_guests}} {{$pluralWord(type.max_guests,'guest')}}</p>
              </div>  

              <!-- Bed -->
              <div v-if="$isNotEmptyV2(type.bed)" class="w-100 mb-2-5 d-flex align-items-start">
                <svg class="mr-2 flex-0 mt-1" width="18" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_10076_83605)">
                  <path d="M0 10.703C0 11.0313 0.208366 11.2397 0.536701 11.2397H0.91555C1.23757 11.2397 1.45225 11.0313 1.45225 10.703V9.76854C1.52171 9.78745 1.73007 9.80011 1.88161 9.80011H14.1184C14.2699 9.80011 14.4783 9.78745 14.5478 9.76854V10.703C14.5478 11.0313 14.7624 11.2397 15.0845 11.2397H15.4633C15.7916 11.2397 16 11.0313 16 10.703V6.9398C16 5.73379 15.3307 5.0708 14.1247 5.0708H1.8753C0.669299 5.0708 0 5.73379 0 6.9398V10.703Z" fill="#777"/>
                  <path d="M1.51538 4.16849H3.11917V3.25926C3.11917 2.67204 3.44751 2.35002 4.04735 2.35002H6.40251C6.99606 2.35002 7.32441 2.67204 7.32441 3.25926V4.16849H8.75769V3.25926C8.75769 2.67204 9.08603 2.35002 9.71746 2.35002H11.9274C12.5588 2.35002 12.8871 2.67204 12.8871 3.25926V4.16849H14.4972V2.35634C14.4972 1.18822 13.8658 0.588379 12.7293 0.588379H3.27702C2.14048 0.588379 1.51538 1.18822 1.51538 2.35634V4.16849Z" fill="#868686"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_10076_83605">
                  <rect width="16" height="10.6646" fill="white" transform="translate(0 0.35791)"/>
                  </clipPath>
                  </defs>
                </svg>
                <p class="mb-0 body-2-1">
                  <template v-for="(bed, index) in type.bed">
                    {{bed.qty}} {{bed.name}}
                    <span v-if="index + 1 < type.bed.length">, </span>
                  </template>
                </p>
              </div>

              <!-- Facility -->
              <template v-if="$isNotEmptyV2(facilityHighlight)">
                <div v-for="facility in facilityHighlight" class="w-100 mb-2-5 d-flex">
                  <div class="mr-2 flex-0 lh-1">
                    <img :src="facility.icon" width="18">
                  </div>
                  <p class="mb-0 body-2-1">
                    {{facility.name}}
                  </p>
                </div>

                <div v-if="facilityHighlight.length < type.facility.length" class="w-100 mb-2-5 d-flex cursor-pointer" @click="onBack('room_type_detail', type);onBack('handlePopupFilter', 'detail-room');postLog('SEARCH','room');hitGoogleAnalytics('room_detail')">
                  <svg class="mr-2 flex-0" width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.99507 19.9901C15.463 19.9901 19.9901 15.4532 19.9901 9.99507C19.9901 4.52718 15.4532 0 9.98528 0C4.52718 0 0 4.52718 0 9.99507C0 15.4532 4.53698 19.9901 9.99507 19.9901ZM9.99507 18.3244C5.36991 18.3244 1.67565 14.6203 1.67565 9.99507C1.67565 5.36991 5.36011 1.66585 9.98528 1.66585C14.6105 1.66585 18.3244 5.36991 18.3244 9.99507C18.3244 14.6203 14.6203 18.3244 9.99507 18.3244Z" fill="var(--merchant-primary-color)"/>
                    <path d="M5.4483 9.99507C5.4483 10.4752 5.78147 10.7986 6.28123 10.7986H9.16214V13.6894C9.16214 14.1793 9.49536 14.5223 9.9755 14.5223C10.4654 14.5223 10.8084 14.1891 10.8084 13.6894V10.7986H13.6991C14.1891 10.7986 14.5321 10.4752 14.5321 9.99507C14.5321 9.50514 14.1891 9.16214 13.6991 9.16214H10.8084V6.28123C10.8084 5.78147 10.4654 5.43851 9.9755 5.43851C9.49536 5.43851 9.16214 5.78147 9.16214 6.28123V9.16214H6.28123C5.78147 9.16214 5.4483 9.50514 5.4483 9.99507Z" fill="var(--merchant-primary-color)"/>
                  </svg>

                  <p class="mb-0 body-2-1 text-green">And more facilities</p>
                </div>
              </template>
            </div>

            <!-- BUTTON DETAIL -->
            <div class="w-100">
              <p class="mb-0 overline cursor-pointer text-green border-green w-100 p-2 text-center radius-8 text-uppercase" @click="onBack('room_type_detail', type);onBack('handlePopupFilter', 'detail-room');postLog('SEARCH','room');hitGoogleAnalytics('room_detail')"
                style="margin-top: -5px">
                {{$t('hotel.unit-type.'+type.type+'.detail')}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ROOM RATE LIST -->
    <div class="w-100">
      <div class="rounded-4 pt-2">
        <div class="mb-1 position-relative">
          <div class="bg-white px-4 py-3 mb-1 rate-desktop rounded-4 light-card-shadow"
            :class="{
              'z-index-1045 position-relative rate-desktop-white box-shadow-none':is_booking_dropdown == data.id || show_rate == data.id,
              'border-2-green': checkRoomRateHihglight(index)
            }"
            v-for="(data, index) in type.room_rate.slice(0, length_more)">

            <div class="px-3 py-2 bg-green position-absolute" style="top:0px;left:0px;border-radius: 0px 0px 4px 0px;" v-if="checkRoomRateHihglight(index)">
              <p class="mb-0 body-2-4 text-white">{{getBeSortBy()=='room_type'?'LOWEST PRICE':getBeSortBy()=='promotion'?'BIGGEST DISCOUNT':'BEST DEAL'}}</p>
            </div>

            <div class="row slim-grid-row">
              <!-- GENERAL INFORMATION -->
              <div class="col-8 col-md-6 col-lg-7 col-xl-8 mb-1" :class="{'pt-4 mt-2':checkRoomRateHihglight(index)}">
                <!-- name rate -->
                <div class="d-block">
                  <p class=" body-2-2 font-bold text-18 d-block mb-0" style="margin-bottom: -3px">{{data.name}}
                  </p>

                  <div v-if="data.bookable && $roomAvbl(data.room_type.id,data.id) > 0" class="d-flex align-items-center mt-1">
                    <div>
                      <!-- all promo -->
                      <template v-if="data.best_price.promotion_price < 0 && $roomAvbl(data.room_type.id,data.id) > 0">
                        <div class="py-1 px-2 border-orange lh-1 rounded-4 d-table" v-if="promotionCounter(data.dates) != ''">
                          <p class="mb-0 body-3-3-2 text-orange">{{promotionCounter(data.dates)}}</p>
                        </div>
                      </template>
                    </div>
                    <div class="ml-2" v-if="$showDiscountMembership(data.dates)">
                      <div class="py-1 px-2 border-orange lh-1 rounded-4 d-table">
                        <p class="mb-0 body-3-3-2 text-orange">Exclusive Member Price</p>
                      </div>
                    </div>
                  </div>

                  <!-- HIGHTLIGHT -->
                  <ul class="pl-3 my-2">
                    <li><p class="mb-0 body-2-2">{{data.minimum_deposit_value > 0 ? 'Prepayment is required' : 'No Prepayment required'}}</p></li>
                    <li><p class="mb-0 body-2-2">{{data.cancellation_policy.title}}</p></li>
                    <li><p class="mb-0 body-2-2" :class="data.rate.is_included_breakfast?'text-success':'text-danger'">{{data.rate.is_included_breakfast?'Breakfast Included':'No meal included'}}</p></li>
                  </ul>
                  <!-- BUTTON RATE DETAIL -->
                  <p v-if="!getMerchant().search_room_is_show_room_rate_detail && !checkRoomRateDetailInline(index,data)" class="mb-0 body-3-1 d-table cursor-pointer text-green border-bottom-green"
                  @click="onBack('toggleRateBreakdown', 'rates-breakdown', data.id);onBack('handlePopupFilter', 'rate-breakdown');totalGuestIncluded(data);sendMetaCapi(data);trackAnalitycs(data)">
                    {{show_rate_breakdown == data.id?'Hide':'Rate'}} Detail
                  </p>
                </div>
              </div>

              <!-- PRICE AND BUTTON -->
              <div class="col-4 col-md-6 col-lg-5 col-xl-4 mb-1">
                <div class="d-block text-right">
                  <template v-if="data.bookable && $roomAvbl(data.room_type.id,data.id) > 0">
                    <div class="d-block text-right" v-if="checkDiscount(data.dates)">
                      
                      <div class="w-100" v-if="promotionTimeChecker(data.dates)">
                        <p class="body-2-2 text-14 mb-0">Promo ends in <span class="mb-0 px-1 bg-orange mr-1 text-white radius-0 font-bold">{{promo_left.h}}</span>:<span class="mb-0 px-1 bg-orange ml-1 text-white radius-0 font-bold">{{promo_left.m}}</span></p>
                      </div>
                      
                      <!-- <p class="mb-0 body-2-2 text-orange text-14 d-inline-block text-right" v-if="discountAccumulation(getTotalPriceFromDate(data.dates,'final_price',true), (getTotalPriceFromDate(data.dates,'price')+getTotalPriceFromDate(data.dates,'extra_guest_price'))) < 1">
                        1% OFF
                      </p> -->
                      <p class="mb-0 text-orange text-14 font-lato d-inline-block text-right">
                        {{discountAccumulation(getTotalPriceFromDate(data.dates,'final_price',true), (getTotalPriceFromDate(data.dates,'price')+getTotalPriceFromDate(data.dates,'extra_guest_price')))}}% OFF
                      </p>

                      <p class="mb-0 text-14 font-lato-regular text-line-through-lato d-inline-block text-subcolor">
                        {{formatCurrency(getTotalPriceFromDate(data.dates,'price')+getTotalPriceFromDate(data.dates,'extra_guest_price'))}}</p>
                    </div>
                    <p class="mt-1 mb-1 text-26 text-orange font-lato lh-1">
                      {{formatCurrency(getTotalPriceFromDate(data.dates,'final_price',true))}}</p>
                    <div class="d-block mb-2">
                      <p class="mb-1 body-3-1 lh-1 d-block">{{ printTotalNight(data.dates) }}</p>
                      <p v-if="getMerchant().search_room_is_show_tax_fee_note" class="mb-0 body-3-1 text-green lh-1 d-block">(Includes taxes & fees)</p>
                    </div>

                    <template v-if="$showRoomPriceDecoy(data.dates)">
                      <RoomPriceDecoy :room-rate="data" use-tooltip />
                    </template>
                  </template>
                </div>
                <div class="row slim-grid-row">
                  <div class="col-2"></div>
                  <div class="col-10">
                    <div class="text-right">
                      <div class="position-relative" style="bottom: 0">
                        <template v-if="data.bookable">
                          <template v-if="getQty(data.id) != 0">
                            <button 
                              v-if="data.room_type.is_virtual"
                              type="button" 
                              class="button-secondary bg-white text-orange px-3 py-2 mt-2 text-12">
                                Selected
                            </button>
                            <button 
                              v-else
                              type="button" 
                              class="button-secondary bg-white text-orange px-3 py-2 mt-2 text-12"
                              :class="{'position-relative z-index-1042':is_booking_dropdown == data.id}"
                              @click="onBack('toggleBookingRate',data.id);checkAvailability(data)">
                              {{getQty(data.id)}} 
                              <span v-if="getQty(data.id) > 1">{{$t('hotel.unit-type.'+type.type+'.units')}}</span> 
                              <span v-else>{{$t('hotel.unit-type.'+type.type+'.unit')}}</span> 
                                <i 
                                class="simple-icon-arrow-up position-relative" 
                                style="top: 2px;" 
                                v-if="is_booking_dropdown == data.id"></i>
                                <i 
                                class="simple-icon-arrow-down position-relative" 
                                style="top: 2px;" 
                                v-else></i>
                            </button>
                          </template>
                          <template v-else>
                            <template v-if="$roomAvbl(data.room_type.id,data.id) > 0">
                              <button 
                                type="button" 
                                class="button-secondary px-3 py-2 mt-2 text-12"
                                @click="addRoomRate(1, data)"
                                v-if="data.room_type.is_virtual">{{$t('hotel.book-now')}} 
                              </button>
                              <button 
                                type="button" 
                                class="button-secondary px-3 py-2 mt-2 text-12"
                                :class="{'position-relative z-index-1042':is_booking_dropdown == data.id}"
                                @click="onBack('toggleBookingRate',data.id);checkAvailability(data)"
                                v-else>{{$t('hotel.book-now')}} 
                                  <i 
                                  class="simple-icon-arrow-up position-relative" 
                                  style="top: 2px;" 
                                  v-if="is_booking_dropdown == data.id"></i>
                                  <i 
                                  class="simple-icon-arrow-down position-relative" 
                                  style="top: 2px;" 
                                  v-else></i>
                              </button>
                            </template>
                            <button type="button" class="button-disabled border-none px-4 py-2 rounded-4 text-center cursor-disable mt-1" style="box-shadow: 0px 6px 12px #eeeeee3b" v-else>
                              <p class="mb-0 body-2-2 font-semibold text-disabled">{{$t("hotel.sold-out")}}</p>
                            </button>
                          </template>
                          <div class="mt-2" 
                            v-if="showRoomLeft(data.room_type.id,data.id)">
                            <p class="mb-0 body-3-3-2 text-danger"> 
                                 {{printRoomLeft($roomAvbl(data.room_type.id,data.id))}}</p>
                          </div>
                        </template>
                        <template v-else>
                          <button :id="`btn-not-available-${data.id}`" type="button" class="button-disabled border-none px-3 py-2 rounded-4 text-center cursor-disable mt-1 d-flex align-items-center ml-auto" style="box-shadow: 0px 6px 12px #eeeeee3b">
                            <p class="mb-0 body-2-2 font-semibold text-disabled">Not Available</p><i class="simple-icon-question ml-2 text-disabled"></i>
                          </button>
                          <b-tooltip :target="`btn-not-available-${data.id}`" triggers="hover" placement="bottom">
                            <div class="p-2" v-html="printNotAvailableRoomMessage(data)">
                            </div>
                          </b-tooltip>
                        </template>
                      </div>
                    </div>
                    <transition name="fade">
                      <div
                        class="position-absolute bg-white border mt-2 rooms-guest rounded-4 z-index-1038"
                        style="right: -10px;width: 125px;box-shadow: 0px 0px 20px 2px #0000001f"
                        v-if="is_booking_dropdown == data.id">
                        <template v-for="(n, index) in $roomAvbl(data.room_type.id,data.id,true)">
                          <p v-if="n < 6"
                          :class="{'text-green':selected_room_rate == n}"
                          class="mb-0 border-bottom body-2-2 text-14 font-semibold py-2 cursor-pointer text-center hover"
                          @click="toggleBookingRateCart('toggleBookingRateCart', 'add', data, n);addRoomRate(n, data);onBack('handlePopupFilter', false)">
                          {{n}} <span v-if="n > 1">{{$t('hotel.unit-type.'+type.type+'.units')}}</span><span v-else>{{$t('hotel.unit-type.'+type.type+'.unit')}}</span> 
                            <i v-if="selected_room_rate == n" style="left: 4px" class="text-green simple-icon-check position-relative"></i>
                          </p>
                          <p 
                          v-else 
                          class="mb-0 border-bottom body-2-2 text-14 font-semibold py-2 cursor-pointer text-center hover" 
                          @click="moreNight(data)">{{$t('hotel.more-rooms')}} 
                            <span class="text-green" v-if="selected_room_rate > 5">({{$t('hotel.current')}} {{selected_room_rate}})</span>
                          </p>
                        </template>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>

              <div 
                class="col-12" 
                v-if="!getMerchant().search_room_is_show_room_rate_detail && checkRoomRateDetailInline(index,data)">
                <div class="border-top mt-3 py-3">
                  <!-- DESCRIPTION -->
                  <div v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
                    <p class="mb-1 body-2-4">{{$t('general.description')}}</p>
                    
                    <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_room_rate)"></p>
                    
                    <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
                    
                    <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>

                  </div>

                  <!-- RATE INCLUSIONS -->
                  <div class="mt-3" v-if="data.rate.inclusion.length > 0">
                    <p class="mb-1 body-2-4">{{$t('hotel.room-type.include-in-rate')}}</p>
                    <ul  class="pl-3">
                      <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
                        <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
                        <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                      </li>
                    </ul>
                  </div>

                  <!-- BUTTON RATE DETAIL -->
                  <p class="mb-0 body-3-1 d-table cursor-pointer text-green border-bottom-green mt-3"
                  @click="onBack('toggleRateBreakdown', 'rates-breakdown', data.id);onBack('handlePopupFilter', 'rate-breakdown');totalGuestIncluded(data);sendMetaCapi(data);trackAnalitycs(data)">
                    {{show_rate_breakdown == data.id?'Hide':'Rate'}} Detail
                  </p>
                </div>
              </div>
            </div>

            <!-- DETAIL -->
            <transition name="fade">
              <div v-if="show_rate_breakdown == data.id || getMerchant().search_room_is_show_room_rate_detail">
                <div class="border-top mt-3 ">
                  <!-- DESCRIPTION -->
                  <div v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
                    <p class="pt-4 mb-1 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
                    <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-3-3 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_room_rate)"></p>
                    <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
                    <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
                  </div>

                  <!-- CANCELLATION POLICY -->
                  <template v-if="data.cancellation_policy != null">
                    <div class="d-block mb-3 mt-4">
                      <p class="mb-1 body-3-3 text-16 font-bold">{{data.cancellation_policy.title}}</p>
                      <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.cancellation_policy.description"></p>
                    </div>
                  </template>

                  <!-- TERMS & CONDITIONS -->
                  <template v-if="$isNotEmpty(data.term_and_condition_room_rate) || $isNotEmpty(data.term_and_condition_promotion)">
                    <div class="d-block mb-3 mt-4">
                      <div class="mb-3" v-if="$isNotEmpty(data.term_and_condition_room_rate)">
                        <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_room_rate.title}}</p>
                        <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_room_rate.description"></p>
                      </div>
                      <div v-if="$isNotEmpty(data.term_and_condition_promotion)">
                        <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_promotion.title}}</p>
                        <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_promotion.description"></p>
                      </div>
                    </div>
                  </template>

                  <!-- RATE INCLUSIONS -->
                  <template v-if="data.rate.inclusion.length > 0">
                    <p class="pt-3 mb-1 body-3-3 text-16 font-bold">{{$t('hotel.room-type.include-in-rate')}}</p>
                    <div class="height-auto">
                      <ul  class="pl-3">
                        <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
                          <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
                          <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                        </li>
                      </ul>
                    </div>
                  </template>
                  <template v-if="data.bookable && $roomAvbl(data.room_type.id,data.id) > 0">
                    <p class="pt-3 mb-2 body-2-2 text-15 font-bold">{{$t('hotel.rate-breakdown.title')}}</p>
                    <div class="row slim-grid-row pb-2" v-for="(rate_breakdown, index) in data.dates">
                      <div class="col-6">
                        <p class="mb-0 body-2-2 font-regular">{{$formatDate(rate_breakdown.date)}} :</p>
                        <!-- PROMO COMBINATION -->
                        <p class="mb-1 body-2 text-12 text-green font-regular" v-if="rate_breakdown.promotion_price < 0 && promotionCounter(rate_breakdown.promo_combine,true) != '' && rate_breakdown.price >= rate_breakdown.final_price">{{promotionCounter(rate_breakdown.promo_combine,true)}}</p>
                      </div>
                      <div class="col-6 text-right">
                        <!-- PROMO COMBINATION -->
                        <div class="w-100 mb-1 no-ws" v-if="rate_breakdown.promotion_price < 0 && promotionCounter(rate_breakdown.promo_combine,true) != ''">
                          <p 
                            class="mb-0 d-inline-block align-middle mr-2 body-3-3-2 text-orange">
                            {{ 
                              +parseFloat(
                                100
                                - $getPercentage(
                                  rate_breakdown.price
                                  + rate_breakdown.extra_guest_price,
                                  printTotalPriceWithTax(rate_breakdown.final_price, rate_breakdown.taxes),
                                  2))
                                  .toFixed(2) }}%
                          </p>
                          <p class="mb-0 body-2 text-12 font-regular text-line-through d-inline-block align-middle" >
                            {{formatCurrency(rate_breakdown.price+rate_breakdown.extra_guest_price)}}
                          </p>
                        </div>
                        <p class="mb-0 body-2-2 font-semibold underline text-15 d-table float-right hover-here">{{formatCurrency(printTotalPriceWithTax(rate_breakdown.final_price, rate_breakdown.taxes))}}
                        </p>

                        <!-- POPOVER -->
                        <div class="hover-element bg-white border px-4 py-3 text-left position-absolute box-shadow-bold rounded-4 hover-rates" style="width: 275px">
                          <p class="mb-2 body-2-2 font-bold text-15">{{$t('hotel.rate-breakdown.rates-detail-price')}} : </p>
                          <div class="row slim-grid-row">
                            <div class="col-4 mb-1">
                              <p class="mb-0 body-2-2 font-regular">{{$t('hotel.date.date')}} :</p>
                            </div>
                            <div class="col-8 mb-1 text-right">
                              <p class="mb-0 body-2-2 font-regular">{{$formatDate(rate_breakdown.date)}}</p>
                            </div>
                            <div class="col-12 mt-2">
                              <div class="row slim-grid-row mb-2">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{printGuestIncluded(data.rate.guest_included)}}x {{$t('hotel.rate-breakdown.guest-included')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.price)}}</p>
                                </div>
                              </div>

                              <!-- extra adult -->
                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.adult.qty > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.adult.qty}}x {{$t('hotel.rate-breakdown.extra-adults')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.adult.total)}}</p>
                                </div>
                              </div>
                              <!-- extra child -->
                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.child.qty > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.child.qty}}x {{$t('hotel.rate-breakdown.extra-childs')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.child.total)}}</p>
                                </div>
                              </div>
                              <!-- extra infant -->
                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.infant.qty > 0">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.infant.qty}}x {{$t('hotel.rate-breakdown.extra-infants')}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.infant.total)}}</p>
                                </div>
                              </div>

                              <!-- GREEN TAX -->
                              <div class="d-flex align-items-center justify-content-between mb-2" v-if="getMerchant().search_room_is_show_tax_fee_note && rate_breakdown.taxes > 0">
                                <p class="mb-0 body-3-3-2 font-regular">Green Tax</p>
                                <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.taxes)}}</p>
                              </div>

                              <!-- promotion -->
                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.promotion_price < 0 && promotionCounter(rate_breakdown.promo_combine,true) != '' && (rate_breakdown.price+rate_breakdown.extra_guest_price) >= printTotalPromotionAmount(rate_breakdown)">
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular">{{promotionCounter(rate_breakdown.promo_combine,true)}}</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-3-3-2 font-regular text-right text-orange">-{{formatCurrency(printTotalPromotionAmount(rate_breakdown))}}</p>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row slim-grid-row mt-2 border-top pt-3">
                                <div class="col-6">
                                  <p class="mb-0 body-2-2 font-bold">{{$t('hotel.total')}} :</p>
                                </div>
                                <div class="col-6 text-right">
                                  <p class="mb-0 body-2-2 font-bold">{{$formatCurrency(printTotalPriceWithTax(rate_breakdown.final_price, rate_breakdown.taxes))}}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <template v-if="$roomAvbl(data.room_type.id,data.id)">
                  <div class="row slim-grid-row mt-2 border-top pt-2">
                    <div class="col-6">
                      <p class="mb-0 body-2-2 font-semibold text-16">{{$t('hotel.rate-breakdown.full-rates')}} : </p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-2-2 text-18 font-bold">
                        {{formatCurrency(getTotalPriceFromDate(data.dates, 'final_price', true))}}</p>
                    </div>
                  </div>
                </template>
              </div>
            </transition>
          </div>
          <template v-if="type.room_rate.length > 5">
            <div class="rounded-4 text-center border-black cursor-pointer bg-white py-2 mt-2" v-if="rates_more" @click="toggleShowMoreRates(true,type.room_rate.length)">
              <p class="mb-0 body-2-2 font-semibold text-14">{{$t('hotel.show-more-rates')}}</p>
            </div>
            <div class="rounded-4 text-center border-black cursor-pointer bg-white py-2 mt-2" v-else @click="toggleShowMoreRates(false,type.room_rate.length)">
              <p class="mb-0 body-2-2 font-semibold text-14">{{$t('hotel.show-less')}}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- Rate select more then 5 -->
    <div v-if="booking_rate_more">
      <div class="position-relative w-100" style="z-index: 1050">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
            <div class="custom-container-fluid px-0">
              <div class="justify-content-center no-gutters">
                <div class="w-100 position-relative">
                  <div style="background-color: #00000099">
                    <div class="w-100 py-2 px-2" style="height: 100vh;">
                      <div>
                        <div class="position-relative bg-white" style="z-index: 1051">
                          <div class="row no-gutters justify-content-center">
                            <div class="fixed-bottom d-table w-100 nav-bottom" style="top:220px">
                              <div class="custom-container-fluid px-0">
                                <div class="row justify-content-center no-gutters">
                                  <div class="col-3 bg-white rounded-4 position-relative">
                                    <div class="px-3 py-3">
                                      <p class="mb-3 body-2-2 font-semibold text-16">{{$t('hotel.unit-type.'+type.type+'.more-unit')}}</p>
                                      <div class="my-2 text-center">
                                        <p class="body-3-3 mb-2" v-if="showRoomLeft(booking_rate_more.room_type.id,booking_rate_more.id)">{{printRoomLeft($roomAvbl(booking_rate_more.room_type.id,booking_rate_more.id))}}</p>
                                        <input 
                                        @keypress="inputCustomOnly" 
                                        type="text" 
                                        :ref="'inputmore'" 
                                        v-model="more_room"
                                        :placeholder="$t('general.input-here')" 
                                        class="form-control mb-2 text-center font-regular"
                                        :class="{'border-danger':is_room_avlb_not_valid}">
                                        <p v-if="is_room_avlb_not_valid" class="body-3-3 mb-1 text-danger">{{$t('hotel.unit-type.'+type.type+'.more-unit-warning')}}</p>
                                      </div>
                                      <div class="row slim-grid-row pt-2">
                                        <div class="col-6">
                                          <button class="button-black w-100" @click="moreNight(false)">{{$t('general.cancel')}}</button>
                                        </div>
                                        <div class="col-6">
                                          <button disabled="disabled" class="button-primary w-100 button-disabled" v-if="is_room_avlb_not_valid">{{$t('hotel.book-now')}}</button>
                                          <button class="button-primary w-100" @click="addRoomRate(more_room,booking_rate_more);moreNight(false);onBack('toggleBookingRate',false);onBack('handlePopupFilter',false)" v-else>{{$t('hotel.book-now')}}</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {formatCurrency,formatDate,inputCustomOnly} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex'
  import moment from 'moment'
  import RoomPriceDecoy from '../RoomPriceDecoy.vue';
import { trackEvent } from '../../../../utils/analytics';


  export default{
    props: ['type','header_scroll','is_booking_dropdown','show_rate','show_rate_breakdown','is_active','formatDate','totalRateBreakdown','toggleBookingRate','popup_active','type_index','rt_hightlight_index','type_avlb', 'roomRateHighlight'],
    components:{
      Flickity,
      RoomPriceDecoy
    },
    data(){
      return{
        more_policy: true,
        more_inclusions: true,
        prevNext: false,
        flickityOptionsRoom: {
          prevNextButtons: false,
          initialIndex: 0,
          pageDots: true,
          adaptiveHeight: false,
          draggable: false,
          wrapAround: true,
        },
        total_guest_included:'',
        booking_rate_more: false,
        is_popup_avlb: false,
        is_popup_avlb_form: false,
        more_room: 6,
        availability: 0,
        get_data_rates: '',
        length_more: 5,
        rates_more: true,
        action_success:{
          show: false,
          message: '',
          timer: 0
        } 
      }
    },
    computed:{
      is_room_avlb_not_valid(){
        let display = 0
        if (this.more_room == '' || this.more_room == 0 || this.more_room > this.$roomAvbl(this.booking_rate_more.room_type.id,this.booking_rate_more.id)) {
          display = true
        } 
        return display
      },
      selected_room_rate(){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == this.get_data_rates.id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }
        return display
      },
      show_success(){
        return this.action_success.show
      },
      promo_left(){
        let time_end = moment().hour(23).minute(59).second(59)
        let time_now = moment()
        let timer = moment.duration(moment(time_end).diff(moment(time_now)))
        let return_data = {
          h: timer.hours() > 10 ? timer.hours() : '0'+timer.hours(),
          m: timer.minutes() > 10 ? timer.minutes() : '0'+timer.minutes()
        }
        return return_data
      },
      room_type_url(){
        var full_url = `${window.location.origin}/${this.getMerchant().code}/hotel-direct-detail/room_type/room_type/${this.type.id}`;
        return full_url
      },
      facilityHighlight(){
        if(this.$isEmpty(this.type) && this.$isEmpty(this.type.facility)) return [];

        const hightlight = this.type.facility.filter(f => this.$isNotEmptyV2(f.is_highlight) && f.is_highlight);

        if(this.$isEmpty(hightlight)) return this.type.facility.slice(0, 5);

        return hightlight;
      }
    },
    watch:{
      show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
    },
    methods:{
      ...mapGetters(['getBeSortBy','getBeFilter','getBeCartRoom','getBeRoomAvbl','getMerchant','getCurrentLanguage']),
      ...mapMutations(['BeManipulateRoomRate','changeBeRoomAvbl','beRemoveRoomRate','BeManipulateRoomRateGuest']),
      printTotalPriceWithTax(price, taxes){
        let showTax = this.getMerchant().search_room_is_show_tax_fee_note
        return showTax ? price : price - taxes
      },
      printTotalPromotionAmount(rate){
        let showTax = this.getMerchant().search_room_is_show_tax_fee_note

        const { price, extra_guest_price, final_price, taxes } = rate;
        
        let baseWithExtra = price + extra_guest_price
        let finalPriceWithTax = final_price;

        if(showTax) baseWithExtra += taxes
        else finalPriceWithTax -= taxes
        
        return baseWithExtra - finalPriceWithTax;
      },
      discountAccumulation(counter, base) {
        let display = ((base - counter) * 100) / base;
        return +parseFloat(display).toFixed(2);
      },
      printTotalNight(dates){
        const totalNight = dates.length
        const unit = this.$t(`hotel.unit-type.${this.type.type}.per-unit`);
        return `${unit} for ${totalNight} ${this.$pluralWord(totalNight, 'night')}`
      },
      inputCustomOnly($event){
        inputCustomOnly('number',$event)
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      printRoomLeft(qty){
        if(this.getCurrentLanguage() == 'en' && qty == 1){
          return `${qty} ${this.$t('hotel.unit-type.'+this.type.type+'.unit')} left`
        }else{
          return `${qty} ${this.$t('hotel.unit-type.'+this.type.type+'.units')} left`
        }
      },
      checkRoomRateHihglight(roomRateIndex){
        let validRoomType = this.roomRateHighlight.roomTypeIndex === this.type_index;
        let validRoomRate = this.roomRateHighlight.roomRateIndex === roomRateIndex;
        return validRoomType && validRoomRate;
      },  
      checkRoomRateDetailInline(roomRateIndex, roomRate){
        const isDetailShown = this.show_rate_breakdown === roomRate.id
        const isDataEmpty = this.$isEmpty(roomRate.description_room_rate) && this.$isEmpty(roomRate.description_promotion) && this.$isEmpty(roomRate.rate.inclusion);        
        if(isDetailShown || isDataEmpty) return false

        const isHightlight = this.checkRoomRateHihglight(roomRateIndex);
        const isRoomRateAloneAndAvailable = this.type.room_rate.length == 1 && this.type_avlb > 0;
        const isBookable = roomRate.bookable;
        if(isBookable && (isHightlight || isRoomRateAloneAndAvailable)) return true;

        return false;
      },
      printNotAvailableRoomMessage(roomRate){
        if(!roomRate) return '';
        
        if(roomRate.stop_sell) return 'Sorry, the room you selected is unavailable for booking on the chosen dates.';

        let { check_in, check_out } = this.getBeFilter().date
        
        if(roomRate.closed_to_arrival){
          const checkinDate = this.$formatDate(check_in);
          return `Sorry, we cannot accept new arrivals for check-in on <b>${checkinDate}</b>. Please choose a different check-in date.`;
        }
        
        if(roomRate.closed_to_departure){
          const checkoutDate = this.$formatDate(check_out);
          return `Sorry, check-out on <b>${checkoutDate}</b> is not available. Please adjust your stay by extending or shortening your booking.`;
        }

        const totalNightStay = this.$countDays(check_in, check_out);
        
        if(totalNightStay < roomRate.min_nights) return `Sorry, the room requires a minimum stay of <b>${roomRate.min_nights} ${this.$pluralWord(roomRate.min_nights, 'night')}</b>. Please extend your stay to meet the requirement.`;
        
        if(totalNightStay > roomRate.max_nights) return `Sorry, the maximum stay for this room is <b>${roomRate.max_nights} ${this.$pluralWord(roomRate.max_nights, 'night')}</b>. Please shorten your booking to fit within the allowed stay.`;
        
      },
      showRoomLeft(rt_id,rr_id){
        let indicator = this.getMerchant().room_availability_max_show
        let room_left = this.$roomAvbl(rt_id,rr_id)
        let is_not_show = indicator == 0
        let is_show_all = indicator == null
        let show_limited = room_left <= indicator

        if(is_not_show || room_left == 0) return false
        else if(is_show_all || show_limited) return true
      },
      checkDiscount(data){
        let total_promo_price = 0

        data.forEach(date=>{
          if(date.promo_combine != null){
            let promo_valid = date.promo_combine.promotion_list.filter(x=>x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
            if(promo_valid.length > 0){
              total_promo_price += date.promo_combine.total_promotion_price
            }
          }
        })

        if(total_promo_price < 0){
          return true
        }else{
          return false
        }
      },
      getTotalPriceFromDate(data,return_data,calTaxes = false){
        const showTax = this.getMerchant().search_room_is_show_tax_fee_note
        let total = 0;
        let totalTaxes = 0;
        data.forEach(date=>{
          total += date[return_data];
          totalTaxes += date.taxes;
        })
        if(!showTax && calTaxes) total -= totalTaxes
        return total
      },
      postLog(modules,event){
        let e = event
        if(event == 'room'){
          e = this.getBeSortBy() == 'room_type' ? 'Clicked Room Type Detail' : 'Clicked Rate Detail'
        }
        this.$postLog(modules,'',e)
      },
      onBack(type,data1,data2){
        this.$emit(type,data1,data2)
      },
      hitGoogleAnalytics(event){
        if(this.getMerchant().google_analytics_id != null){
          if(this.getMerchant().google_analytics_id != ''){
            this.$gtag('event',event, { method: 'Google' })
          }
        }
      },
      toggleBookingRateCart(button, type, data, qty = 1){
        this.$emit(button,type,data,qty)
      },
      isToggle(type,data){
        if (type == 'policy') {
          this.more_policy = data
        }else if(type == 'inclusions') {
          this.more_inclusions = data
        }
      },
      // PROMO COMBINATION
      promotionCounter(data,is_preview=false){
        let promotion = []
        if(is_preview){
          if(data != null){
            let promotion_list = this.promotionCounterPerDate(data.promotion_list)
            for(let i=promotion_list.length-1;i>=0;i--){
              let item = promotion_list[i]
              if(promotion.length == 0){
                promotion += item.name
              }else{
                promotion += `, ${item.name}`
              }
            }
          }
          return promotion
        }
        else{
          for(let i = 0; i < data.length; i++){
            if(data[i].promo_combine != null){
              let promotion_list_per_date = this.promotionCounterPerDate(data[i].promo_combine.promotion_list)
              promotion = promotion.concat(promotion_list_per_date)
            }
          }
          promotion = promotion.filter((v,i,a)=>a.findIndex(v2=>(v2.id===v.id))===i)
          let display = ''
          if(promotion.length == 1){
            display = promotion[0].name
          }else if(promotion.length > 1){
            display = promotion[promotion.length-1].name+' and '+(promotion.length-1)+' Other'
          }
          return display
        }
      },
      promotionCounterPerDate(promo_list){
        let promotion = []
        promo_list.forEach((item,index)=>{
          let validate = {
            price: item.promotion_price < 0,
            not_ro: item.promotion_type != 'REMAINING_OCCUPANCY',
            is_apply: item.is_apply
          }
          if(validate.price && validate.not_ro && validate.is_apply){
            if(promotion.length == 0){
              promotion.push({
                id: item.id,
                name: item.name
              })
            }else{
              let record = promotion.findIndex(x=>x.id == item.id)
              if(record == -1){
                promotion.push({
                  id: item.id,
                  name: item.name
                })
              }
            }
          }
        })
        return promotion
      },
      promotionTimeChecker(data){
        let today = moment().format('YYYY-MM-DD')
        let total_promo_exp_today = []
        data.forEach(date=>{
          if(date.promo_combine != null){
            let promo_valid = date.promo_combine.promotion_list.filter(x=>x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
            promo_valid.forEach(promo_item=>{
              if(promo_item.is_use_custom_sale_stay_date && today == promo_item.sale_date[0].end_date){
                total_promo_exp_today.push(promo_item)
              }
            })
          }
        })
        return total_promo_exp_today.length > 0 ? true : false
      },
      totalGuestIncluded(data){
        let total = this.getBeFilter().guest.adult+this.getBeFilter().guest.child+this.getBeFilter().guest.infant
        if(total  <= data.rate.guest_included){
          this.total_guest_included = total

        }else{
         this.total_guest_included = data.rate.guest_included
        }
      },
      printGuestIncluded(guest_included){
        const { adult, child, infant } = this.getBeFilter().guest;
        const total = Number(adult) + Number(child) + Number(infant);
        return total <= guest_included ? total : guest_included
      },
      moreNight(data){
        if (data != false) {
          this.booking_rate_more = data
          let self = this
          this.$nextTick(() => {
            self.$refs['inputmore'].focus()
            self.$refs['inputmore'].select()
          })
        }else{
          this.booking_rate_more = false
        }
      },
      roomRateVisible(avlb){
        return (avlb.index < 5 ) ? avlb.index : 6
      },
      addToCart(data,n){
        if(!n.is_limit){
          this.toggleBookingRateCart('toggleBookingRateCart', 'add', data, n.counter);
          this.addRoomRate(n.counter, data);
          this.onBack('handlePopupFilter', false)
        }
      },
      updateRoomTypeAvailability(qty, currentRoomRate, action){
        const { 
          id: rr_id, 
          room_type: { id, is_virtual, availability_affected } 
        } = currentRoomRate
        let availabilityParams = { 
          id, 
          rr_id, 
          is_virtual, 
          availability_affected, 
          action,
          qty 
        }
        this.changeBeRoomAvbl(availabilityParams);
      },
      generateRemainingGuestFilter(){
        const GUEST_TYPE = ['adult','child','infant'];

        let remainingGuestFilter = this.$deepCopy(this.getBeFilter().guest)
        this.getBeCartRoom().forEach(savedRoomRate => {
          savedRoomRate.guest.forEach(savedRoomRateGuest => {
            const { included, extra } = savedRoomRateGuest;
            
            const savedGuestsPerRoomRate = GUEST_TYPE.reduce((acc, key) => {
              acc[key] = included[key] + extra[key];
              return acc;
            }, {});
            GUEST_TYPE.forEach(guest => {
              if(remainingGuestFilter[guest] > 0){
                remainingGuestFilter[guest] -= savedGuestsPerRoomRate[guest]
              } else {
                remainingGuestFilter[guest] = 0
              } 
            })
          });
        })
        return remainingGuestFilter
      },
      includeGuestParamsIfZeroTotal(guest_included, roomConfig){
        let guestIncluded = { adult: 0, child: 0, infant: 0 }
        const currentGuestFilter = this.$deepCopy(this.getBeFilter().guest)

        const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = roomConfig
        
        if(use_max_guest_by_pax){
          guestIncluded.adult = Math.min(guest_included, max_guest_adult);

          let remainingPax = guest_included - guestIncluded.adult;

          if (currentGuestFilter.child > 0 && remainingPax > 0) {
            guestIncluded.child = Math.min(remainingPax, max_guest_children);
            remainingPax -= guestIncluded.child;
          }

          if (currentGuestFilter.infant > 0 && remainingPax > 0) {
            guestIncluded.infant = Math.min(remainingPax, max_guest_infant);
          }
        }else{
          if(currentGuestFilter.adult > guest_included){
            guestIncluded = { adult: guest_included, child: 0, infant: 0 }
          }else{
            guestIncluded.adult = currentGuestFilter.adult
            const remainingGuestIncludedAfterAdult = guest_included - currentGuestFilter.adult
        
            if(remainingGuestIncludedAfterAdult > 0){
              
              if(currentGuestFilter.child > remainingGuestIncludedAfterAdult){
                guestIncluded.child = remainingGuestIncludedAfterAdult
              }else{
                guestIncluded.child = currentGuestFilter.child
                const { adult, child } = guestIncluded
                const remainingGuestIncludedAfterAdultChild = guest_included - (adult + child)
                const isInfantExist = currentGuestFilter.infant > remainingGuestIncludedAfterAdultChild
                if(remainingGuestIncludedAfterAdultChild > 0 && isInfantExist){
                  guestIncluded.infant = remainingGuestIncludedAfterAdultChild
                }
              }
            }
          }
        }
        return guestIncluded;
      },
      allocateGuestPerRoom(guestParamsIncluded, remainingGuestFilter, guest_included){
        let includedGuest = guestParamsIncluded
        let remainingGuest = remainingGuestFilter
        
        const GUEST_TYPE = ['adult','child','infant'];
        GUEST_TYPE.forEach(guest => {
          let totalGuestIncludedPerRoom = Object.values(includedGuest).reduce((sum, value) => sum + value, 0);
          if(remainingGuest[guest] > 0 && totalGuestIncludedPerRoom < guest_included){
            let remainingPaxPerRoom = guest_included - totalGuestIncludedPerRoom
            if(remainingGuest[guest] > guest_included){
              includedGuest[guest] = remainingPaxPerRoom
              remainingGuest[guest] -= remainingPaxPerRoom
            }else{
              includedGuest[guest] = remainingPaxPerRoom > remainingGuest[guest] ? remainingGuest[guest] : remainingPaxPerRoom
              remainingGuest[guest] -= includedGuest[guest]
            }
          }
        });
        return { includedGuest, remainingGuest }
      },
      allocateSpecificGuestPerRoom(remainingGuests, maxGuests, includedGuests){
        let allocatedGuests = { adult: 0, child: 0, infant: 0 };
        let remainingIncluded = includedGuests;

        const allocate = (type) => {
          if (remainingIncluded <= 0) return;
          const count = Math.min(remainingGuests[type], maxGuests[type], remainingIncluded);
          allocatedGuests[type] = count;
          remainingGuests[type] -= count;
          remainingIncluded -= count;
        }

        allocate('adult');
        allocate('child');
        allocate('infant');

        return allocatedGuests;
      },
      generateRoomRateGuestParam(selectedRoomRateQty, currentRoomRate){
        let finalCountGuests = []
        
        const { rate, room_type } = currentRoomRate
        const {
          use_max_guest_by_pax = false,
          max_guests = null,
          max_guest_adult = 0,
          max_guest_children = 0,
          max_guest_infant = 0,
        } = rate.max_guests ? rate : room_type;
        const roomConfig = {use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant}

        const GUEST_TYPE = ['adult','child','infant'];
        let remainingGuestFilter = this.generateRemainingGuestFilter()
        const totalRemainingGuestFilter = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

        for (let i = 0; i < selectedRoomRateQty; i++) {
          let guestParams = {
            included: { adult: 0, child: 0, infant: 0 },
            extra: { adult: 0, child: 0, infant: 0 },
          }
          
          if(totalRemainingGuestFilter === 0){
            guestParams.included = this.includeGuestParamsIfZeroTotal(rate.guest_included, roomConfig)
            finalCountGuests.push(guestParams);
          }else{
            
            // Calculate guest included
            if(use_max_guest_by_pax){
              const maxGuests = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
              guestParams.included = this.allocateSpecificGuestPerRoom(remainingGuestFilter, maxGuests, rate.guest_included);
            }else{
              if(totalRemainingGuestFilter > rate.guest_included){
                const { includedGuest, remainingGuest } = this.allocateGuestPerRoom(guestParams.included, remainingGuestFilter, rate.guest_included)
                guestParams.included = includedGuest
                remainingGuestFilter = remainingGuest
              }else{
                guestParams.included = remainingGuestFilter
                remainingGuestFilter = { adult: 0, child: 0, infant: 0 }
              }
            }
            
            finalCountGuests.push(guestParams);

            // Calculate extra guest
            const isLastLooper = i+1 === selectedRoomRateQty;
            if(isLastLooper){
              let notIncludedGuest = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)
              if(notIncludedGuest > 0){
                for(let j = 0; j < selectedRoomRateQty; j++){
                  let guestPerQtyRoom = finalCountGuests[j]
                  if(use_max_guest_by_pax){
                    const maxGuestsPerType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
                    const guestIncluded = guestPerQtyRoom.included
                    
                    for (const type of GUEST_TYPE){
                      let remainingPaxForExtra = maxGuestsPerType[type] - guestIncluded[type];
                      if(remainingPaxForExtra <= 0) continue;

                      const totalCurrentGuest = Object.values(finalCountGuests[j]).flatMap(Object.values).reduce((a, b) => a + b, 0);
                      if(max_guests <= totalCurrentGuest) continue;

                      const remainingFromMaxGuests = max_guests - totalCurrentGuest;
                      const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type], remainingFromMaxGuests);
                      finalCountGuests[j].extra[type] = extraFinal;
                      remainingGuestFilter[type] -= extraFinal;
                    }

                  }else{
                    let totalGuestIncludedPerRoom = Object.values(guestPerQtyRoom.included).reduce((sum, value) => sum + value, 0);  
                    let remainingPaxForExtra = max_guests-totalGuestIncludedPerRoom

                    for (const type of GUEST_TYPE) {
                      if (remainingPaxForExtra > 0 && remainingGuestFilter[type] > 0) {
                        const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type]);
                        finalCountGuests[j].extra[type] = extraFinal;
                        remainingGuestFilter[type] -= extraFinal;
                        remainingPaxForExtra -= extraFinal
                      }
                      
                    }
                  }
                }
              }
            }
          }
        }

        return finalCountGuests;
      },
      addRoomRate(qty, selectedRoomRate){
        const validQty = parseInt(qty);
        const currentRoomRate = this.$deepCopy(selectedRoomRate)
        
        const savedRoom = this.$deepCopy(this.getBeCartRoom())
        let savedRoomRateIndex = savedRoom.findIndex(savedRoomRate=>savedRoomRate.room_rate.id === currentRoomRate.id)
        
        if(savedRoomRateIndex != -1){
          this.beRemoveRoomRate(currentRoomRate.id);
          this.updateRoomTypeAvailability(savedRoom[savedRoomRateIndex].qty, currentRoomRate, 'inc')
          setTimeout(()=>{
            this.addRoomRate(validQty, currentRoomRate)
          },100)
        } else {
          this.updateRoomTypeAvailability(validQty, currentRoomRate, 'dec')
          const roomRateParam = {
            room_rate: currentRoomRate,
            qty: validQty,
            guest: this.generateRoomRateGuestParam(validQty, currentRoomRate)
          }
          this.BeManipulateRoomRate(roomRateParam)
          setTimeout(()=>{
            this.updatePriceAccordingToPax(currentRoomRate.id, roomRateParam.guest)
          },100)

          this.$sendEventMetaConversionsAPI('AddToWishlist', {
            id: currentRoomRate.id_ori,
            name: currentRoomRate.name,
            dates: currentRoomRate.dates,
            qty: validQty
          });
          trackEvent("add_to_cart", {roomRate: currentRoomRate, qty: validQty})
        }
      },
      updatePriceAccordingToPax(room_rate_id,guests){
        let guest_params = { 
            id: room_rate_id, 
            guest: {
              included: [],
              extra: []
            } 
          }

          guests.forEach((item,index)=>{
            guest_params.guest.included.push(item.included)
            guest_params.guest.extra.push(item.extra)
          })
          
        this.BeManipulateRoomRateGuest(guest_params)
      },
      checkAvailability(data){
        this.get_data_rates = data
        this.availability = data.availability
        this.more_room = this.selected_room_rate
      },
      toggleShowMoreRates(type,length){
        if (this.rates_more) {
          this.length_more = length
          this.rates_more = false
        }else{
          this.length_more = 5
          this.rates_more = true
        }
      },
      sliderPreviousNext(data){
        this.prevNext = data
      },
      copyLink(){
        var params = {
          type : (this.is_active == 'room_type') ? 'room_type' : 'rate',
          sort_by: this.getBeSortBy()
        } 
        var full_url = window.location.origin+"/"+this.getMerchant().code+'/hotel-direct-detail/'+params.type+'/'+params.sort_by+'/'+this.type.id;
        var input_temp = document.createElement("input");
        input_temp.value = full_url;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Link copied!'
        this.action_success.timer = 1
      },
      getQty(id){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }else{
          display = 0
        }
        return display
      },
      slideTheSlider(action='next'){
        if(this.$refs.flickity){
          if(action === 'next') this.$refs.flickity.next();
          else this.$refs.flickity.previous();
        }
      },
      sendMetaCapi(data){
        setTimeout(() => {
          if(this.show_rate_breakdown !== data.id) return;
  
          this.$sendEventMetaConversionsAPI('ViewContent', {
            id: data.id_ori,
            name: data.name,
            dates: data.dates
          }, 'Room Rate');
        }, 100);
      },
      trackAnalitycs(data=null){
        if(this.show_rate_breakdown === data.id) return;
        trackEvent('view_item', data);
      }
    }
  }
</script>
<style scoped>

  .rooms-guest:after,
  .rooms-guest:before {
    position: absolute;
    display: inline-block;
    content: "";
    top: -6px;
  }

  .rooms-guest:after {
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    border-left: 7px solid transparent;
  }

  .rooms-guest:before {
    top: -7px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 7px solid #ccc;
  }

  .hover-rates{
    bottom: 25px;
    right: 0;
    z-index: 9;
  }

  .top-90{
    top: 90px !important;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/room.vue